import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, eyebrow, children, footer, size = "md", testId }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    if (open) {
      window.addEventListener("keydown", onKey);
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        window.removeEventListener("keydown", onKey);
        document.body.style.overflow = prev;
      };
    }
  }, [open, onClose]);

  if (!open) return null;
  const widths = { sm: "max-w-md", md: "max-w-2xl", lg: "max-w-4xl", xl: "max-w-6xl" };

  // Rendered into document.body so it is always centered in the viewport,
  // regardless of any transformed/scrolled ancestor (e.g. the animated <main>).
  return createPortal(
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4" data-testid={testId}>
      <div className="absolute inset-0 bg-black/55 backdrop-blur-[2px]" onClick={onClose} />
      <div className={`relative w-full ${widths[size]} brutalist-card max-h-[90vh] overflow-hidden flex flex-col`}>
        <div className="px-5 py-4 border-b border-border flex items-start justify-between">
          <div>
            {eyebrow && <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{eyebrow}</div>}
            <div className="font-display text-xl tracking-tight mt-0.5">{title}</div>
          </div>
          <button onClick={onClose} className="p-1.5 border border-border hover:bg-accent text-muted-foreground" style={{ borderRadius: 4 }} data-testid="modal-close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="px-5 py-5 overflow-y-auto flex-1">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-border flex justify-end gap-2">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</label>
      <div className="mt-1.5">{children}</div>
    </div>
  );
}
